import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import './Styles/Styles.scss';
import { Provider } from 'react-redux';
import { setSession } from './Redux/Actions';
import Store from './Redux/Store';
import Routes from './Routes/Routes';
import Helpers from './Helpers/Helpers';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';

const UnitExecutorSelector = ({ executors = [], onConfirm = () => {} }) => {
  const [selected, setSelected] = useState('');
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
      <div style={{ background: '#fff', borderRadius: 8, padding: 20, minWidth: 360, maxWidth: 480, boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>
        <h5 style={{ margin: 0, marginBottom: 10 }}>Seleccionar Unidad Ejecutora</h5>
        <p style={{ marginTop: 0, color: '#555' }}>Debe elegir una unidad para continuar.</p>
        <select value={selected} onChange={e => setSelected(e.target.value)} style={{ width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', marginBottom: 12 }}>
          <option value="">-- Seleccione --</option>
          {executors.map(u => <option key={u.id} value={u.id}>{u.id} - {u.name}</option>)}
        </select>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button onClick={() => onConfirm(selected)} disabled={!selected} style={{ background: '#28a745', color: '#fff', border: 0, borderRadius: 4, padding: '8px 14px', cursor: selected ? 'pointer' : 'not-allowed' }}>
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
}

const App = () => {
  const [content, setContent] = useState(<div style={{
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }}>
    <img src={Helpers.config.api.images + '/dashboard/preloading.svg'} alt="Preloading" />
  </div>);

  useEffect(() => {
    axios({
      url: Helpers.config.api.url + '/users/session',
      method: 'POST',
      data: {
        jwt: Helpers.localStorage.getJWT()
      }
    }).then(res => {
      return res.data;
    }).then(res => {
      if (res.message === 'error_session_api') {
        localStorage.clear();
        setContent(<Provider store={Store}>
          <Routes type="auth" />
          <ToastContainer />
        </Provider>);
      } else {
        Store.dispatch(setSession(res.data));
        Helpers.localStorage.setSession({
          jwt: res.data.jwt
        });

        // Unidades ejecutoras del backend
        const executors = res.data.executors || [];
        const assigned = Helpers.localStorage.getUnitExecutorAssigned();

        if (!assigned || !assigned.id) {
          if (executors.length === 1) {
            Helpers.localStorage.setUnitExecutorAssigned({ id: executors[0].id, name: executors[0].name });
            window.location.reload();
            return;
          } else if (executors.length > 1) {
            // Mostrar SOLO el selector, no la app detrás
            setContent(
              <UnitExecutorSelector executors={executors} onConfirm={(idSel) => {
                const chosen = executors.find(e => String(e.id) === String(idSel));
                if (chosen) {
                  // Pedir nuevo token con unidad asignada
                  axios({
                    url: Helpers.config.api.url + '/users/session',
                    method: 'POST',
                    data: { jwt: Helpers.localStorage.getJWT(), unit_executor_assigned: chosen.id }
                  }).then(r => r.data).then(r => {
                    if (r.message !== 'error_session_api') {
                      Helpers.localStorage.setSession({ jwt: r.data.jwt });
                      Helpers.localStorage.setUnitExecutorAssigned({ id: chosen.id, name: chosen.name });
                      window.location.reload();
                    }
                  })
                }
              }} />
            );
            return;
          } else {
            // Sin ejecutoras (no debería pasar por la validación del backend)
            setContent(<Provider store={Store}>
              <Routes />
              <ToastContainer />
            </Provider>);
          }
        } else {
          setContent(<Provider store={Store}>
            <Routes />
            <ToastContainer />
          </Provider>);
        }
      }
    }).catch(req => {
      console.log(req);
    });
  }, []);

  return content;
}

console.log('%cCARLOS ESTHEFANO HUAMAN MARCOS', 'color: RED; font-size: 20px; font-weight: bold');
console.log('%cDESARROLLADOR DE SISTEMAS', 'color: RED; font-size: 15px; font-weight: bold');
console.log('%cPERU', 'color: RED; font-size: 15px; font-weight: bold');
console.log('%cCELULAR +51 933642273', 'color: RED; font-size: 15px; font-weight: bold');
console.log('%cEMAIL carhuaman1995@gmail.com', 'color: RED; font-size: 15px; font-weight: bold');

ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.unregister();